import IconFaceMask from '@picsart/icons/IconFaceMask';
import IconBlankWrite from '@picsart/icons/IconBlankWrite';
import IconRefresh from '@picsart/icons/IconRefresh';
import IconEmail from '@picsart/icons/IconEmail';
import IconCreditCard from '@picsart/icons/IconCreditCard';
import IconFonts from '@picsart/icons/IconFonts';
import IconHashtag from '@picsart/icons/IconHashtag';
import IconText from '@picsart/icons/IconText';
import IconMonitoring from '@picsart/icons/IconMonitoring';
import IconAlignLeft from '@picsart/icons/IconAlignLeft';
import IconCropInstagramSquare from '@picsart/icons/IconCropInstagramSquare';
import IconEmbedCode from '@picsart/icons/IconEmbedCode';
import IconDetails from '@picsart/icons/IconDetails';
import IconColorExposure from '@picsart/icons/IconColorExposure';
import IconList from '@picsart/icons/IconList';

import { ICopywriterCategories } from '../utils/common/types';

export const AD_WRITER_CATEGORY = 0;
export const SOCIAL_MEDIA_BIO_CATEGORY = 1;
export const REPHRASER_CATEGORY = 2;
export const MARKETING_SLOGAN_CATEGORY = 3;
export const BUSINESS_NAME_CATEGORY = 4;
export const INSTAGRAM_HASHTAG_CATEGORY = 5;
export const PRODUCT_DESCRIPTION_CATEGORY = 6;
export const LINKEDIN_BIO_GENERATOR_CATEGORY = 7;
export const INSTAGRAM_CAPTION_CATEGORY = 8;
export const PAGE_OUTLINE_CATEGORY = 9;
export const WEBPAGE_COPY_CATEGORY = 10;
export const META_DATA_MAKER_CATEGORY = 11;
export const COLOR_PALETTE_MAKER_CATEGORY = 12;
export const EMAIL_WRITER_CATEGORY = 13;
export const RESUME_EXPERIENCE_CATEGORY = 14;
export const SUMMARIZER_CATEGORY = 15;

export const VALID_CATEGORIES = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15];

export const TOOLS_WITH_ONE_RESULT = [5, 9, 11, 12, 13, 15];
export const TOOLS_WITHOUT_REPHRASE_OPTION = [2, 5, 9, 10, 12, 14];
export const TOOLS_WITH_ADDITIONAL_INFO_REPHRASE = [11];
export const TOOLS_WITH_LANGUAGE_PARAM = [
  AD_WRITER_CATEGORY,
  BUSINESS_NAME_CATEGORY,
  PRODUCT_DESCRIPTION_CATEGORY,
];

export const VALID_TONES = [
  'friendly',
  'luxury',
  'relaxed',
  'professional',
  'bold',
  'adventurous',
  'witty',
  'persuasive',
  'empathetic',
];
export const DEFAULT_TONE = 'friendly';

export const AD_WRITER_LINK = `/text/ai-writer/editor/?id=${AD_WRITER_CATEGORY}`;

export const CATEGORY_ICON_PROPS = {
  width: 24,
  height: 24,
  background: 'transparent',
  fill: '#808080',
};

export const COPYWRITER_CATEGORIES: ICopywriterCategories[] = [
  {
    id: AD_WRITER_CATEGORY,
    label: 'Ad Copy',
    src: IconBlankWrite,
  },
  {
    id: SOCIAL_MEDIA_BIO_CATEGORY,
    label: 'Social Media Bio',
    src: IconFaceMask,
  },
  {
    id: REPHRASER_CATEGORY,
    label: 'Rephraser',
    src: IconRefresh,
  },
  {
    id: MARKETING_SLOGAN_CATEGORY,
    label: 'Marketing Slogan',
    src: IconEmail,
  },
  {
    id: BUSINESS_NAME_CATEGORY,
    label: 'Business Name',
    src: IconCreditCard,
  },
  {
    id: INSTAGRAM_HASHTAG_CATEGORY,
    label: 'Hashtag Ideas',
    src: IconHashtag,
  },
  {
    id: PRODUCT_DESCRIPTION_CATEGORY,
    label: 'Product Description',
    src: IconFonts,
  },
  {
    id: LINKEDIN_BIO_GENERATOR_CATEGORY,
    label: 'Linkedin Headline',
    src: IconText,
  },
  {
    id: INSTAGRAM_CAPTION_CATEGORY,
    label: 'Instagram Caption',
    src: IconCropInstagramSquare,
  },
  {
    id: PAGE_OUTLINE_CATEGORY,
    label: 'Landing Page Outline',
    src: IconMonitoring,
  },
  {
    id: WEBPAGE_COPY_CATEGORY,
    label: 'Webpage Copy',
    src: IconAlignLeft,
  },
  {
    id: META_DATA_MAKER_CATEGORY,
    label: 'Meta Data Maker',
    src: IconEmbedCode,
  },
  {
    id: SUMMARIZER_CATEGORY,
    label: 'Summarizer',
    src: IconList,
  },
  {
    id: COLOR_PALETTE_MAKER_CATEGORY,
    label: 'Color Palette',
    src: IconColorExposure,
    otherTool: true,
  },
  {
    id: RESUME_EXPERIENCE_CATEGORY,
    label: 'Resume Experience',
    src: IconDetails,
  },
  {
    id: EMAIL_WRITER_CATEGORY,
    label: 'Email Writer',
    src: IconEmail,
  },
];

export const PRODUCT_CATEGORIES = [0, 3, 6, 9, 11, 13];
export const DESCRIPTION_CATEGORIES = [4, 14];
export const KEYWORDS_CATEGORIES = [9, 10, 11];

export const FORM_INITIAL_VALUES = {
  product: '',
  description: '',
  callToAction: '',
  tone: 'friendly',
  businessType: '',
  specialOffers: '',
  characterLimit: '',
  tellUsAboutYourself: '',
  textToParaphrase: '',
  language: 'english',
  wordToStart: '',
  numberOfResults: '10',
  keywords: '',
  linkedinKeywords: '',
  purpose: '',
  role: '',
  achievements: '',
  adWriterRadioValue: 'body',
  describeYourImage: '',
  paragraphTitle: '',
  textToBeSummarised: '',
  format: 'short paragraph',
  textPurpose: '',
  describeText: '',
  describeScene: '',
  numberOfColors: '5',
  jobTitle: '',
  previousJobTitle: '',
};

export const TONE_VALUES = [
  {
    title: '😊 Friendly',
    value: 'friendly',
  },
  {
    title: '💎 Luxury',
    value: 'luxury',
  },
  {
    title: '😌 Relaxed',
    value: 'relaxed',
  },
  {
    title: '💼 Professional',
    value: 'professional',
  },
  {
    title: '💪 Bold',
    value: 'bold',
  },
  {
    title: '⛺ Adventurous',
    value: 'adventurous',
  },
  {
    title: '💡 Witty',
    value: 'witty',
  },
  {
    title: '🧠 Persuasive',
    value: 'persuasive',
  },
  {
    title: '😍 Empathetic',
    value: 'empathetic',
  },
];

export const LANGUAGE_VALUES = [
  {
    title: 'English/(US)',
    value: 'english',
  },
  {
    title: 'Simplified Chinese/中文(简体)',
    value: 'chinese',
  },
  {
    title: 'German/Deutsch',
    value: 'german',
  },
  {
    title: 'French/Français',
    value: 'french',
  },
  {
    title: 'Italian/Italiano',
    value: 'italian',
  },
  {
    title: 'India/Hindi',
    value: 'hindi',
  },
  {
    title: 'Japanese/日本',
    value: 'japanese',
  },
  {
    title: 'Korean/한국어',
    value: 'korean',
  },
  {
    title: 'Russian/Русский',
    value: 'russian',
  },
  {
    title: 'Spanish/Español',
    value: 'spanish',
  },
];

export const LANGUAGES_WITHOUT_WORD_COUNT = ['chinese', 'hindi', 'japanese', 'korean', 'russian'];

export const MAX_CHRS = 1000;
export const MIN_CHRS = 100;
export const TEXT_ROWS = 3;
export const DEFAULT_CHARACTER_LIMIT_WEBPAGE_COPY = '400';

export const MAX_NO_OF_RESULTS = 60;
export const MINUTES_FOR_MAX_NO_OF_RESULTS = 60;
export const LOCAL_STORAGE_RESULTS_KEY = 'qt_no_of_results';
export const LOCAL_STORAGE_SESSION_KEY = 'qt_session_id';
export const A_B_EXPERIMENT_ID = 'IWOo9n7bSJS-hp01rxjhvw';
export const ADS_GENERATOR_EXPERIMENT_ID = 't1L82hqST3qQ0qJ5yep2PA';
export const BIO_GENERATOR_EXPERIMENT_ID = 'WZnbaHaMR_-hjV9cLrIOqQ';
export const GPT_VERSION = 'gpt-3.5-turbo';
export const COLOR_PALETTE_GENERATOR_URL = 'color/palette-generator';

export const GENERAL_LANDING_CARD_SECTION_IMGS = [
  {
    src: 'https://cdn140.picsart.com/68721397183638063211.webp',
  },
  {
    src: 'https://cdn140.picsart.com/38242970981570235865.webp',
  },
  {
    src: 'https://cdn140.picsart.com/30068252809047449629.webp',
  },
  {
    src: 'https://cdn140.picsart.com/94188132819015905082.webp',
  },
];

//ORDER OF PARAMS IS IMPORTANT NOW. CHECK HERE: https://picsart.atlassian.net/wiki/spaces/ST/pages/3321463202/Natural+Language+Input+Statements
export const AD_WRITER_BODY_PARAMS = [
  { value: 'adWriterRadioValue', analyticsValue: 'ad_writer_radio' },
  { value: 'product', analyticsValue: 'product' },
  { value: 'description', analyticsValue: 'description' },
  { value: 'businessType', analyticsValue: 'business_type' },
  { value: 'specialOffers', analyticsValue: 'special_offers' },
  { value: 'callToAction', analyticsValue: 'call_to_action' },
  { value: 'tone', analyticsValue: 'tone' },
  {
    value: 'characterLimit',
    noTrim: true,
    analyticsValue: 'character_limit',
  },
  { value: 'language', analyticsValue: 'language' },
];

export const BIO_BODY_PARAMS = [
  {
    value: 'tellUsAboutYourself',
    analyticsValue: 'tell_us_about_yourself',
  },
  { value: 'tone', analyticsValue: 'tone' },
  { value: 'callToAction', analyticsValue: 'call_to_action' },
];

export const REPHRASER_BODY_PARAMS = [
  { value: 'textToParaphrase', analyticsValue: 'text_to_paraphrase' },
  { value: 'tone', analyticsValue: 'tone' },
];

export const MARKETING_SLOGAN_BODY_PARAMS = [
  { value: 'product', analyticsValue: 'product' },
  { value: 'description', analyticsValue: 'description' },
  { value: 'tone', analyticsValue: 'tone' },
];

export const BUSINESS_NAME_BODY_PARAMS = [
  { value: 'description', analyticsValue: 'description' },

  { value: 'businessType', analyticsValue: 'business_type' },
  { value: 'tone', analyticsValue: 'tone' },
  { value: 'language', analyticsValue: 'language' },
  {
    value: 'characterLimit',
    noTrim: true,
    analyticsValue: 'character_limit',
  },
];

export const INSTAGRAM_HASHTAG_BODY_PARAMS = [
  {
    value: 'numberOfResults',
    analyticsValue: 'number_of_results',
    noTrim: true,
  },
  {
    label: 'word to start',
    value: 'wordToStart',
    analyticsValue: 'word_to_start',
  },
];

export const PRODUCT_DESCRIPTION_BODY_PARAMS = [
  { value: 'product', analyticsValue: 'product' },
  { value: 'keywords', analyticsValue: 'keywords' },
  { value: 'businessType', analyticsValue: 'business_type' },
  { value: 'tone', analyticsValue: 'tone' },
  {
    value: 'characterLimit',
    noTrim: true,
    analyticsValue: 'character_limit',
  },
  { value: 'language', analyticsValue: 'language' },
];

export const LINKEDIN_BIO_GEN_BODY_PARAMS = [
  { value: 'role', analyticsValue: 'role' },
  { value: 'achievements', analyticsValue: 'achievements' },
  { value: 'linkedinKeywords', analyticsValue: 'linkedin_keywords' },
  { value: 'tone', analyticsValue: 'tone' },
];

export const EMAIL_WRITER_BODY_PARAMS = [
  { value: 'purpose', analyticsValue: 'purpose' },
  { value: 'product', analyticsValue: 'product' },
  { value: 'callToAction', analyticsValue: 'callToAction' },
  { value: 'tone', analyticsValue: 'tone' },
  {
    value: 'characterLimit',
    noTrim: true,
    analyticsValue: 'character_limit',
  },
];

export const INSTAGRAM_CAPTION_PARAMS = [
  { value: 'describeYourImage', analyticsValue: 'describe_your_image' },
  { value: 'callToAction', analyticsValue: 'callToAction' },
  { value: 'tone', analyticsValue: 'tone' },
];

export const PAGE_OUTLINE_PARAMS = [
  { value: 'product', analyticsValue: 'product' },
  { value: 'description', analyticsValue: 'description' },
  { value: 'keywords', analyticsValue: 'keywords' },
];

export const WEBPAGE_COPY_BODY_PARAMS = [
  { value: 'paragraphTitle', analyticsValue: 'paragraph_title' },
  { value: 'tone', analyticsValue: 'tone' },
  {
    value: 'characterLimit',
    noTrim: true,
    analyticsValue: 'character_limit',
  },
  { value: 'keywords', analyticsValue: 'keywords' },
];

export const META_DATA_MAKER_BODY_PARAMS = [
  { value: 'product', analyticsValue: 'product' },
  { value: 'keywords', analyticsValue: 'keywords' },
  { value: 'description', analyticsValue: 'description' },
];

export const SUMMARIZER_BODY_PARAMS = [
  { value: 'textToBeSummarised', analyticsValue: 'text_to_be_summarised' },
  { value: 'format', analyticsValue: 'format' },
  { value: 'textPurpose', analyticsValue: 'text_purpose' },
  { value: 'describeText', analyticsValue: 'describe_text' },
];
export const COLOR_PALETTE_MAKER_BODY_PARAMS = [
  { value: 'describeScene', analyticsValue: 'describe_a_scene' },
  { value: 'numberOfColors', analyticsValue: 'number_of_colors' },
];
export const RESUME_EXPERIENCE_PARAMS = [
  { value: 'jobTitle', analyticsValue: 'job_title' },
  { value: 'previousJobTitle', analyticsValue: 'previous_job_title' },
  { value: 'description', analyticsValue: 'description' },
];

export const quicktoolsLogoSrc =
  'https://pastatic.picsart.com/cms-pastatic/227d1042-e9d3-4f4d-b720-0e1505dfd52c.webp';
